import React from "react";
import "reactjs-popup/dist/index.css";
import dateFormat, { masks } from "dateformat";
import Popup from "reactjs-popup";
import moment from "moment";
// Date.isLeapYear = function (year) {
//   return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
// };

// Date.getDaysInMonth = function (year, month) {
//   return [
//     31,
//     Date.isLeapYear(year) ? 29 : 28,
//     31,
//     30,
//     31,
//     30,
//     31,
//     31,
//     30,
//     31,
//     30,
//     31,
//   ][month];
// };

// Date.prototype.isLeapYear = function () {
//   return Date.isLeapYear(this.getFullYear());
// };

// Date.prototype.getDaysInMonth = function () {
//   return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
// };

// Date.prototype.addMonths = function (value) {
//   var n = this.getDate();
//   this.setDate(1);
//   this.setMonth(this.getMonth() + value);
//   this.setDate(Math.min(n, this.getDaysInMonth()));
//   return this;
// };
export const getToDate = (fromDate, days, months, years) => {
  let toDate = moment(fromDate)
    .add(years, "years")
    .add(months, "months")
    .add(days, "days");

  // var _tempDate = new Date(fromDate);
  // _tempDate.setDate(_tempDate.getDate() + Number(days - Number(1)));
  // _tempDate.addMonths(Number(months));
  // _tempDate.setYear(_tempDate.getFullYear() + Number(years));
  // var dd = ("0" + _tempDate.getDate()).slice(-2);
  // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
  // var y = _tempDate.getFullYear();
  // var someFormattedDate = y + "-" + mm + "-" + dd;

  return moment(toDate).subtract(1, "days").format("YYYY-MM-DD");
};

export const PopupMessage = (props) => {
  return (
    <Popup open={props.open} position="top center">
      {(close) => (
        <div>
          {/* {props.content} */}
          <div dangerouslySetInnerHTML={{ __html: props.content }} />
          <a className="close" onClick={props.redirectAfterSave}>
            &times;
          </a>
          <div>
            <button type="button" onClick={props.redirectAfterSave}>
              Ok
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export const InfoPopupMessage = (props) => {
  return (
    <Popup open={props.open} position="top center">
      {(close) => (
        <div>
          {props.content}
          <a className="close" onClick={props.infoClose}>
            &times;
          </a>
          <div>
            <button type="button" onClick={props.infoOk}>
              Ok
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export const ChartPopup = (props) => {
  return (
    <Popup open={props.open} position="top center">
      {(close) => (
        <div>
          {props.content}

          <div className="button_group d-flex align-items-center gap-3 justify-content-center">
            <button className="add_button" type="button" onClick={close}>
              Ok
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export const leaseDateFormat = (date) => {
  if (date == "0000-00-00") {
    return "-";
  } else {
    return dateFormat(date, "dd mmm yyyy");
  }
};

export const exceldataFormate = (res) => {
  const excelData = [];
  var res = { data: res };
  for (let i = 0; i < res.data.x.length; i++) {
    let points = {};
    // points[res.data.axis['x']]=res.data.x[i];
    if (
      typeof res.data.axis != "" &&
      typeof res.data.axis != "undefined" &&
      typeof res.data.axis["x"] != "undefined" &&
      typeof res.data.x != "undefined"
    ) {
      points[res.data.axis["x"]] = res.data.x[i];
    } else {
      points[res.data.axis["x"]] = "city";
    }
    if (
      typeof res.data.axis != "undefined" &&
      typeof res.data.axis["x"] != "undefined" &&
      typeof res.data.label != "undefined"
    ) {
      points[res.data.axis["x"]] = res.data.label[i];
    }

    if (
      typeof res.data.legend["y1"] != "undefined" &&
      typeof res.data.datapoints["y1"] != "undefined" &&
      res.data.datapoints["y1"]
    ) {
      points[res.data.legend["y1"]] = res.data.datapoints["y1"][i];
    }
    if (
      typeof res.data.legend["y2"] != "undefined" &&
      typeof res.data.datapoints["y2"] != "undefined" &&
      res.data.datapoints["y2"]
    ) {
      points[res.data.legend["y2"]] = res.data.datapoints["y2"][i];
    }
    if (
      typeof res.data.legend["y3"] != "undefined" &&
      typeof res.data.datapoints["y3"] != "undefined" &&
      res.data.datapoints["y3"]
    ) {
      points[res.data.legend["y3"]] = res.data.datapoints["y3"][i];
    }
    if (
      typeof res.data.legend["y4"] != "undefined" &&
      typeof res.data.datapoints["y4"] != "undefined" &&
      res.data.datapoints["y4"]
    ) {
      points[res.data.legend["y4"]] = res.data.datapoints["y4"][i];
    }
    if (
      typeof res.data.legend["y5"] != "undefined" &&
      typeof res.data.datapoints["y5"] != "undefined"
    ) {
      points[res.data.legend["y5"]] = res.data.datapoints["y5"][i];
    }
    if (
      typeof res.data.legend["y1"] != "undefined" &&
      typeof res.data.datapoints['"5k_to_10k"'] != "undefined"
    ) {
      points[res.data.legend["y1"]] = res.data.datapoints['"5k_to_10k"'][i];
    }
    if (
      typeof res.data.legend["y2"] != "undefined" &&
      typeof res.data.datapoints["10k_to_20k"] != "undefined"
    ) {
      points[res.data.legend["y2"]] = res.data.datapoints["10k_to_20k"][i];
    }
    if (
      typeof res.data.legend["y3"] != "undefined" &&
      typeof res.data.datapoints["20k_to_50k"] != "undefined"
    ) {
      points[res.data.legend["y3"]] = res.data.datapoints["20k_to_50k"][i];
    }
    if (
      typeof res.data.legend["y4"] != "undefined" &&
      typeof res.data.datapoints["50k_to_100k"] != "undefined"
    ) {
      points[res.data.legend["y4"]] = res.data.datapoints["50k_to_100k"][i];
    }
    if (
      typeof res.data.legend["y5"] != "undefined" &&
      typeof res.data.datapoints["<_5k"] != "undefined"
    ) {
      points[res.data.legend["y5"]] = res.data.datapoints["<_5k"][i];
    }
    if (
      typeof res.data.legend["y6"] != "undefined" &&
      typeof res.data.datapoints["<_100k"] != "undefined"
    ) {
      points[res.data.legend["y6"]] = res.data.datapoints["<_100k"][i];
    }

    if (
      typeof res.data.legend != "undefined" &&
      typeof res.data["y"] != "undefined"
    ) {
      points[res.data.legend] = res.data["y"][i];
    }
    if (
      typeof res.data.legend["y1"] != "undefined" &&
      typeof res.data.datapoints.y1 != "undefined" &&
      res.data.datapoints.y1 &&
      typeof res.data.datapoints.y1.data != "undefined"
    ) {
      points[res.data.legend["y1"]] = res.data.datapoints.y1.data[i];
    }
    if (
      typeof res.data.legend["y2"] != "undefined" &&
      typeof res.data.datapoints.y2 != "undefined" &&
      res.data.datapoints.y2 &&
      typeof res.data.datapoints.y2.data != "undefined"
    ) {
      points[res.data.legend["y2"]] = res.data.datapoints.y2.data[i];
    }
    if (
      typeof res.data.legend["y3"] != "undefined" &&
      typeof res.data.datapoints.y3 != "undefined" &&
      res.data.datapoints.y3 &&
      typeof res.data.datapoints.y3.data != "undefined"
    ) {
      points[res.data.legend["y3"]] = res.data.datapoints.y3.data[i];
    }
    if (
      typeof res.data.legend["y4"] != "undefined" &&
      typeof res.data.datapoints.y4 != "undefined" &&
      res.data.datapoints.y4 &&
      typeof res.data.datapoints.y4.data != "undefined"
    ) {
      points[res.data.legend["y4"]] = res.data.datapoints.y4.data[i];
    }
    if (
      typeof res.data.legend["y5"] != "undefined" &&
      typeof res.data.datapoints.y5 != "undefined" &&
      res.data.datapoints.y5 &&
      typeof res.data.datapoints.y5.data != "undefined"
    ) {
      points[res.data.legend["y5"]] = res.data.datapoints.y5.data[i];
    }
    excelData.push(points);
  }

  return excelData;
};

export const piexceldataFormate = (res, xTitle, yTitle) => {
  const excelData = [];
  console.log(res, "result pie 275");
  for (let i = 0; i < res.x.length; i++) {
    let points = {};
    if (typeof res.x != "undefined") {
      points[xTitle] = res.x[i];
    }
    if (typeof res.axis.y != "undefined") {
      points[yTitle] = res.datapoints.y1[i];
    }
    excelData.push(points);
  }
  console.log(excelData, "excel data ");
  return excelData;
};
